import { ReactElement } from 'react'
import { ContextProps, createContext } from '../common/contextHelper'
import { useAuthContext } from './AuthContext'
import { useWindowDimensions } from '../hooks/useWindowDimensions'

interface ThemeContextState {
  showLogo: boolean
}

const [Provider, useThemeContext] = createContext<ThemeContextState>(module.filename)

const SMALL_SCREEN_HEIGHT = 900

export { useThemeContext }

export function ThemeProvider({ children }: ContextProps): ReactElement {
  const { isAuthorized } = useAuthContext()
  const { height } = useWindowDimensions()

  const showLogo = height > SMALL_SCREEN_HEIGHT || !isAuthorized

  return (
    <Provider
      value={{
        showLogo,
      }}
    >
      {children}
    </Provider>
  )
}
